import {
    Box,
    Button,
    Divider,
    Grid,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { getAppItem } from "Components/AppChip";
import GoBack from "Components/GoBack";
import { AvironLoading } from "Components/Icons/AvironLoading";
import MemberLink from "Components/MembershipPage/MemberLink";
import PageTitle from "Components/PageTitle";
import { useTrackingData } from "Components/TrackingData";
import UnderlineButton from "Components/base/Button/UnderLineButton";
import { CONSTANTS } from "consts";
import { MEMBERSHIP_INTERVAL, MEMBERSHIP_TRACKING_TYPE, MembershipProductType } from "consts/membership";
import { MEMBERSHIP_STATUS } from "consts/statusMembership";
import { UserAppContext } from "contexts";
import get from "lodash/get";
import set from "lodash/set";
import moment from "moment";
import { default as React, useContext, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useWindowSize } from "scripts/useWindowSize";
import { capitalizeFirstLetter } from "scripts/utils/string";
import { gameServerApi } from "services/gameServerV2";
import {
    GetAvironSubscriptionQuery,
    useCancelUserSubscriptionMutation,
    useChangeUserSubscriptionPlanMutation,
    useCheckCancelOfferAvaiableSubscriptionQuery,
    useCheckUserReceiveMembershipOfferQuery,
    useClaimCancelOfferSubscriptionMutation,
    useFitplanChooseSubscriptionMutation,
    useGetAvironSubscriptionQuery,
    useGetAvironSubscriptionReceiptsLazyQuery,
    usePlansQuery,
    useReactiveUserSubscriptionMutation,
    useResumePaymentSubscriptionMutation,
    useRetryChargeSubscriptionMutation,
    useSharedQuery
} from "services/webServer";
import Swal from "sweetalert2";
import { formatAppIds } from "utils/membership";
import { getUrlVars } from "utils/url";
import useHandleActivePage from "utils/useHandleActivePage";
import { getStatus } from "../Main/MembershipsMain.constant";
import { MEMBERSHIP_CREATED_AT_2025 } from "../UpgradePlan/hook";
import { handleCheckIsFreeMembership } from "../utils/handleCheckIsFreeMembership";
import CancelOfferMembershipModal from "./CancelOfferMembership";
import ChangeMembershipModal from "./ChangeMembership";
import style from "./Detail.module.scss";
import EnrollLifetimeWarrantyModal from "./EnrollLifetimeWarranty";
import FitPlanChooseMembershipModal from "./FitPlanChooseMembership";
import KlaviyoUpgradeMembershipModal from "./KlaviyoUpgradeMembership";
import KlaviyoUpgradeMembershipSuccessModal from "./KlaviyoUpgradeMembership/SuccessModal";
import ReactiveMembershipModal from "./ReactiveMembershipNotice";
import ReactiveMembershipWithoutPromoModal from "./ReactiveMembershipNoticeWithoutPromo";
import Receipts from "./Receipts";
import ResumeMembershipModal from "./ResumeMembership";
import RetryChargeMembershipModal from "./RetryChargeMembership";
import "./style.scss";


const initModalState = {
    openChange: false,
    openUpgradePlan: false,
    openUpgradePlanSuccess: false,
    openCancel: false,
    openSuccess: false,
    openError: false,
    openPause: false,
    openResume: false,
    openCancelOffer: false,
    openCancelNotice: false,
    openCancelOfferSuccess: false,
    openRetryCharge: false,
    openEnrollLifetimeWarranty: false,
    openReactive: false,
    openReactiveWithoutPromo: false,
    openFitPlanChooseMembership: false,
    cancelData: {
        reason: "",
        reasonDetail: "",
    },
};
const ROWS_PER_PAGE: number = 10;

export interface ISubmitPauseSubscription {
    resumesAt: string;
    reason: string;
    note: string;
}


export default function MembershipDetail() {
    useHandleActivePage(CONSTANTS.SIDEBAR_PAGEID.MEMBERSHIPS);
    const params: any = useParams();
    const history = useHistory();
    const location = useLocation();
    const { auth } = useContext(UserAppContext);
    const userId = useMemo(() => auth?.id, [auth]);

    const [changeUserSubscription] = useChangeUserSubscriptionPlanMutation();
    const [cancelUserSubscription] = useCancelUserSubscriptionMutation();
    const [resumePaymentSubscription] = useResumePaymentSubscriptionMutation();
    const [claimCancelOffer] = useClaimCancelOfferSubscriptionMutation();
    const [retryChargeSubscription] = useRetryChargeSubscriptionMutation();
    const [reactiveUserSubscription] = useReactiveUserSubscriptionMutation();
    const [fitplanChooseSubscription] = useFitplanChooseSubscriptionMutation();
    const {
        trackingPauseOrCancelMembershipClick,
        trackingCancelMembershipClick,
    } = useTrackingData(params.id);
    const [modalState, setModalState] = React.useState(initModalState);
    const [pagination, setPagination] = React.useState({
        totalPage: 1,
        currentPage: 0,
    });
    const [membershipData, setMembershipData] = React.useState<any>({});
    const [isOwnerMembership, setIsOwnerMembership] = useState(false);
    const windowSize = useWindowSize();
    const [loadingPage, setLoadingPage] = useState(false);
    const [isReCall, setIsReCall] = useState(false);

    const { data: checkUserReceivedMembershipOffer } =
        useCheckUserReceiveMembershipOfferQuery({
            variables: {
                userId: userId,
            },
            skip: Boolean(!userId),
            fetchPolicy: "no-cache",
        });

    const resetState = () => {
        setModalState(initModalState);
    };

    const [state, setState] = React.useState({
        receipts: [],
        totalCount: 0,
        processing_change_plan: false,
        change_plan_invoice_url: undefined,
    });

    const { data: userData } = useSharedQuery();
    const { data: planData, loading: loadingPlan } = usePlansQuery();
    const { data: checkCancelOfferData, refetch: refetchCheckCancelOfferData } =
        useCheckCancelOfferAvaiableSubscriptionQuery({
            fetchPolicy: "no-cache",
        });

    const { data, loading, refetch } = useGetAvironSubscriptionQuery({
        variables: {
            id: params.id,
        },
        fetchPolicy: "no-cache",
        notifyOnNetworkStatusChange: true,
        skip: Boolean(!params?.id),
    });

    useEffect(() => {
        const queryString = getUrlVars();
        const isUpgradePlan = sessionStorage.getItem(`isUpgradePlan-${params.id}`);
        if (
            (queryString.action && queryString.action === "upgrade-plan") &&
            data?.avironSubscription?.plan?.type === "stripe" &&
            (get(data, "avironSubscription.plan.productId") === MembershipProductType.membership
                || get(data, "avironSubscription.plan.productId") === MembershipProductType.membershipWithWarranty) &&
            !isUpgradePlan &&
            data?.avironSubscription?.plan?.interval === "monthly" &&
            (data?.avironSubscription?.state === "active" || data?.avironSubscription?.state === "inactive")
        ) {
            setModalState({
                ...initModalState,
                openUpgradePlan:
                    true,
            });
        }
    }, [data]);

    const [
        getReceiptData,
        {
            data: receiptsData,
            refetch: refetchReceipts,
            loading: receiptLoading,
        },
    ] = useGetAvironSubscriptionReceiptsLazyQuery({
        fetchPolicy: "no-cache",
        variables: {
            id: params.id,
            first: ROWS_PER_PAGE,
            offset: pagination.currentPage * ROWS_PER_PAGE,
        },
        notifyOnNetworkStatusChange: true,
    });

    // checl if user is owner to call get receipt data
    useEffect(() => {
        if (isOwnerMembership) {
            getReceiptData();
        }
    }, [isOwnerMembership]);

    const appId = localStorage.getItem("appId");

    useEffect(() => {
        if (
            [
                CONSTANTS.APP.C2_ROWER,
                CONSTANTS.APP.C2_SKIERG,
                CONSTANTS.APP.C2_BIKEERG,
            ].indexOf(Number(appId)) !== -1
        ) {
            history.push(CONSTANTS.NAVIGATION_URL.MEMBERSHIPS);
        }
    }, [appId]);

    const refetchMembershipDetail = async () => {
        setLoadingPage(true)
        gameServerApi.user
            .getMembershipFamilly({ orgId: params.id })
            .then((res) => {
                setMembershipData(res.data.currentMembership);
                if (
                    res?.data?.currentMembership?.owner?.customId ===
                    userData?.currentUser?.id
                ) {
                    setIsOwnerMembership(true);
                } else {
                    setIsOwnerMembership(false);
                }
                setLoadingPage(false)
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    history.push(CONSTANTS.NAVIGATION_URL.NOT_FOUND);
                }
                setIsOwnerMembership(false);
                setLoadingPage(false)
            });
    }

    useEffect(() => {
        setLoadingPage(true)
        gameServerApi.user
            .getMembershipFamilly({ orgId: params.id })
            .then((res) => {
                setMembershipData(res.data.currentMembership);
                if (
                    res?.data?.currentMembership?.owner?.customId ===
                    userData?.currentUser?.id
                ) {
                    setIsOwnerMembership(true);
                } else {
                    setIsOwnerMembership(false);
                }
                setLoadingPage(false)
            })
            .catch((err) => {
                if (err.response.status === 404) {
                    history.push(CONSTANTS.NAVIGATION_URL.NOT_FOUND);
                }
                setIsOwnerMembership(false);
                setLoadingPage(false)
            });
    }, [userData, isReCall]);

    const isFreeMembership = handleCheckIsFreeMembership(membershipData?.planId);

    const isCommercialMembership = useMemo(() => {
        if (typeof data === "undefined") return false;
        return get(data, "avironSubscription.plan.customerType") === "commercial";
    }, [data])

    const isReceivedMembershipOffer = useMemo(() => {
        if (typeof checkUserReceivedMembershipOffer === "undefined")
            return undefined;

        return Boolean(
            checkUserReceivedMembershipOffer?.checkUserReceiveMembershipOffer
        );
    }, [checkUserReceivedMembershipOffer]);

    const handleCloseNoticeReactiveModal = () => {
        sessionStorage.setItem(`reactive:${params.id}`, "true");
        setModalState(initModalState);
    };

    const handleTrackingCancellationInitiated = () => {
        const subscriptionType =
            data?.avironSubscription?.plan?.interval ===
                MEMBERSHIP_TRACKING_TYPE.MONTHLY
                ? MEMBERSHIP_TRACKING_TYPE.MONTHLY
                : MEMBERSHIP_TRACKING_TYPE.ANNUAL;
    };

    const isCanReactiveWithoutPromo = useMemo(() => {
        if (
            isFreeMembership ||
            isCommercialMembership ||
            typeof isReceivedMembershipOffer === "undefined" ||
            Boolean(isReceivedMembershipOffer)
        ) {
            return false;
        }

        const canReactive = sessionStorage.getItem("reactiveWithoutPromo");
        if (
            canReactive &&
            canReactive === "true" &&
            ["ended"].includes(get(data, "avironSubscription.state")) &&
            get(data, "avironSubscription.plan.type") === "stripe" &&
            get(data, "avironSubscription.plan.isRecurring") &&
            get(data, "avironSubscription.remark.reactive") !== true &&
            isOwnerMembership
        ) {
            const isShowNoticeReactive = sessionStorage.getItem(
                `reactiveWithoutPromo:${params.id}`
            );
            if (!isShowNoticeReactive) {
                setModalState({
                    ...initModalState,
                    openReactiveWithoutPromo: true,
                });
                sessionStorage.setItem(
                    `reactiveWithoutPromo:${params.id}`,
                    "true"
                );
            }
            return true;
        }
        return false;
    }, [data, isCommercialMembership, isReceivedMembershipOffer, isOwnerMembership]);

    useEffect(() => {
        const queryString = getUrlVars();
        if (
            (queryString.action && queryString.action === "fitplan-choose-membership") &&
            ["active"].includes(get(data, "avironSubscription.state")) &&
            (get(data, "avironSubscription.plan.productId") === MembershipProductType.membershipWithFinance
                || get(data, "avironSubscription.plan.productId") === MembershipProductType.membershipWithWarrantyAndFinance)
        ) {
            const isShowed = sessionStorage.getItem(
                `fitplanChoose:${params.id}`
            );
            if (!isShowed) {
                setModalState({
                    ...initModalState,
                    openFitPlanChooseMembership:
                        true,
                });
                sessionStorage.setItem(
                    `fitplanChoose:${params.id}`,
                    "true"
                );
            }

        }
    }, [data]);

    const isFitplan = useMemo(() => {
        return (
            ["active"].includes(get(data, "avironSubscription.state")) &&
            (get(data, "avironSubscription.plan.productId") === MembershipProductType.membershipWithFinance
                || get(data, "avironSubscription.plan.productId") === MembershipProductType.membershipWithWarrantyAndFinance)
        );
    }, [data]);

    const handleCloseNoticeReactiveWithoutPromoModal = () => {
        sessionStorage.setItem(`reactiveWithoutPromo:${params.id}`, "true");
        setModalState(initModalState);
    };

    const isCancelOffer = useMemo(() => {
        if (isFreeMembership) return false;

        if (data) {
            return (
                get(data, "avironSubscription.remark.cancel_offer") &&
                get(data, "avironSubscription.remark.cancel_offer_until") &&
                moment(
                    get(data, "avironSubscription.remark.cancel_offer_until")
                ).isAfter(moment()) &&
                isOwnerMembership
            );
        }
        return false;
    }, [data, isOwnerMembership]);

    const isSubscriptionDiscount = useMemo(() => {
        // if (isFreeMembership) return false;

        if (data) {
            return get(data, "avironSubscription.remark.subscription_discount")
                // && get(data, "avironSubscription.state") === "active"
                && isOwnerMembership
        }
    }, [data, isOwnerMembership])

    const isDuringCancelOffer = useMemo(() => {
        // if (isFreeMembership) return false;

        if (data) {
            console.log("data ne", data)
            console.log(
                "condition 1",
                get(data, "avironSubscription.remark.cancel_offer_until") &&
                moment(
                    get(
                        data,
                        "avironSubscription.remark.cancel_offer_until"
                    )
                ).isAfter(moment()), get(data, "avironSubscription.remark.cancel_offer_until")
            );
            console.log(
                "condition 2",
                get(data, "avironSubscription.remark.cancel_offer_from") &&
                moment(
                    get(
                        data,
                        "avironSubscription.remark.cancel_offer_from"
                    )
                ).isBefore(moment()), get(data, "avironSubscription.remark.cancel_offer_from")
            );
            console.log("isOwnerMembership", isOwnerMembership)
            console.log("join condition", get(data, "avironSubscription.remark.cancel_offer") &&
                get(data, "avironSubscription.remark.cancel_offer_until") &&
                moment(
                    get(data, "avironSubscription.remark.cancel_offer_until")
                ).isAfter(moment()) &&
                get(data, "avironSubscription.remark.cancel_offer_from") &&
                moment(
                    get(data, "avironSubscription.remark.cancel_offer_from")
                ).isBefore(moment()) &&
                isOwnerMembership)
            return (
                get(data, "avironSubscription.remark.cancel_offer") &&
                get(data, "avironSubscription.remark.cancel_offer_until") &&
                moment(
                    get(data, "avironSubscription.remark.cancel_offer_until")
                ).isAfter(moment()) &&
                get(data, "avironSubscription.remark.cancel_offer_from") &&
                moment(
                    get(data, "avironSubscription.remark.cancel_offer_from")
                ).isBefore(moment()) &&
                isOwnerMembership
            );
        }
        return false;
    }, [data, isOwnerMembership]);
    console.log("isDuringCancelOffer: ", isDuringCancelOffer);

    const handleChangePage = (_page: number) => {
        setPagination(set(pagination, "currentPage", _page));
        refetchReceipts({
            id: params.id,
            first: ROWS_PER_PAGE,
            offset: _page * ROWS_PER_PAGE,
        });
    };

    const receipts =
        React.useMemo(() => {
            if (receiptsData && receiptsData.subscriptionReceipts) {
                return receiptsData.subscriptionReceipts.nodes.map(
                    (node: any, index: number) => {
                        let isShowStar: boolean = false;
                        if (
                            index ===
                            (receiptsData?.subscriptionReceipts?.totalCount ||
                                0) -
                            1
                        ) {
                            isShowStar = false;
                        } else if (isCancelOffer) {
                            if (
                                moment(
                                    get(
                                        data,
                                        "avironSubscription.remark.cancel_offer_until"
                                    )
                                ).isAfter(moment(node.periodStart)) &&
                                moment(
                                    get(
                                        data,
                                        "avironSubscription.remark.cancel_offer_from"
                                    )
                                ).isSameOrBefore(moment(node.periodStart))
                            ) {
                                isShowStar = true;
                            }
                        }
                        if (node?.note === "reactive") {
                            isShowStar = true;
                        }
                        return {
                            createdAt: moment(node.createdAt).format(
                                "MM/DD/YYYY"
                            ),
                            periodStart: node.periodStart
                                ? moment(node.periodStart).format("MM/DD/YYYY")
                                : "---",
                            periodEnd: node.periodEnd
                                ? moment(node.periodEnd).format("MM/DD/YYYY")
                                : "---",
                            amount: node.amount / 100,
                            status: capitalizeFirstLetter(node.status),
                            isShowStar: isShowStar,
                        };
                    }
                );
            }
        }, [receiptsData, data]) || [];

    const totalCount =
        React.useMemo(() => {
            if (receiptsData && receiptsData.subscriptionReceipts) {
                return receiptsData.subscriptionReceipts.totalCount;
            }
        }, [receiptsData]) || 0;

    const getAvironKey = (token: string = " ") => {
        return token;
    };

    const ModelCell = useMemo(() => {
        // (models: string[]) => {
        if (membershipData?.appIds?.length > 0) {
            const appIds = formatAppIds(membershipData?.appIds);
            let res = "";
            for (let i = 0; i < appIds.length; i++) {
                if (i !== appIds.length - 1) {
                    res = res + getAppItem(appIds[i]).value + ", ";
                } else {
                    res = res + getAppItem(appIds[i]).value;
                }
            }
            return res;
        }
    }, [membershipData?.appIds]);

    // const submitChangeSubscriptionPlan = async (planId: number) => {
    //     setState(
    //         Object.assign(state, {
    //             processing_change_plan: true,
    //         })
    //     );
    //     setModalState({ ...initModalState, openChange: false });
    //     Swal.showLoading();
    //     const successFunc = async function () {
    //         await Swal.fire(
    //             "Success",
    //             "Membership plan changed successfully.",
    //             "success"
    //         );
    //         // refetch();
    //         // setTimeout(() => {
    //         //     refetchReceipts({
    //         //         id: params.id,
    //         //         first: ROWS_PER_PAGE,
    //         //         offset: 0,
    //         //     });
    //         // }, 2000);
    //         window.location.reload();
    //     };
    //     const errorFunc = async (
    //         message: string = "Change membership plan failed"
    //     ) => {
    //         await Swal.fire("Error", message, "error");
    //         // refetch();
    //         // refetchReceipts({
    //         //     id: params.id,
    //         //     first: ROWS_PER_PAGE,
    //         //     offset: 0,
    //         // });
    //         window.location.reload();
    //     };
    //     try {
    //         const { data } = await changeUserSubscription({
    //             variables: {
    //                 id: params.id,
    //                 planId,
    //             },
    //         });
    //         if (
    //             data &&
    //             data.changeUserSubscriptionPlan &&
    //             (data as any).changeUserSubscriptionPlan.error
    //         ) {
    //             errorFunc(
    //                 "Can't charge your card. We will open a new tab automatically to retry payment for membership. Please reload page after payment successful."
    //             );
    //             setState(
    //                 Object.assign(state, {
    //                     change_plan_invoice_url: (data as any)
    //                         .changeUserSubscriptionPlan.error.invoice
    //                         .hosted_invoice_url,
    //                     processing_change_plan: false,
    //                 })
    //             );
    //             setTimeout(() => {
    //                 window.open(
    //                     (data as any)?.changeUserSubscriptionPlan?.error.invoice
    //                         .hosted_invoice_url
    //                 );
    //             }, 3000);
    //         } else {
    //             successFunc();
    //         }
    //     } catch (err) {
    //         errorFunc();
    //     } finally {
    //         setState({
    //             ...state,
    //             processing_change_plan: false,
    //         });
    //     }
    // };

    const handleCloseKlaviyoUpgradeSuccessModal = () => {
        window.location.reload();
        // resetState();
        // refetch();
        // refetchReceipts({
        //         id: params.id,
        //         first: ROWS_PER_PAGE,
        //         offset: 0,
        //     });
        // setTimeout(() => {

        // }, 2000);
    }

    const submitKlaviyoUpgradeSubscriptionPlan = async (planId: number) => {
        setState(
            Object.assign(state, {
                processing_change_plan: true,
            })
        );
        setModalState({ ...initModalState });
        Swal.showLoading();
        const successFunc = async function () {
            setModalState({ ...initModalState, openUpgradePlanSuccess: true })
            sessionStorage.setItem(`isUpgradePlan-${params.id}`, "1")
            // refetch();
            // setTimeout(() => {
            //     refetchReceipts({
            //         id: params.id,
            //         first: ROWS_PER_PAGE,
            //         offset: 0,
            //     });
            // }, 2000);

        };
        const errorFunc = async (
            message: string = "Change membership plan failed"
        ) => {
            await Swal.fire("Error", message, "error");
            // refetch();
            // refetchReceipts({
            //     id: params.id,
            //     first: ROWS_PER_PAGE,
            //     offset: 0,
            // });
            window.location.reload();
        };
        try {
            const { data } = await changeUserSubscription({
                variables: {
                    id: params.id,
                    planId,
                },
            });
            Swal.close();
            if (
                data &&
                data.changeUserSubscriptionPlan &&
                (data as any).changeUserSubscriptionPlan.error
            ) {
                errorFunc(
                    "Can't charge your card. We will open a new tab automatically to retry payment for membership. Please reload page after payment successful."
                );
                setState(
                    Object.assign(state, {
                        change_plan_invoice_url: (data as any)
                            .changeUserSubscriptionPlan.error.invoice
                            .hosted_invoice_url,
                        processing_change_plan: false,
                    })
                );
                setTimeout(() => {
                    window.open(
                        (data as any)?.changeUserSubscriptionPlan?.error.invoice
                            .hosted_invoice_url
                    );
                }, 3000);
            } else {
                successFunc();
            }
        } catch (err) {
            errorFunc();
        } finally {
            setState({
                ...state,
                processing_change_plan: false,
            });
        }
    };

    const submitChangeSubscriptionPlan = async (planId: number) => {
        setState(
            Object.assign(state, {
                processing_change_plan: true,
            })
        );
        setModalState({ ...initModalState, openChange: false });
        const successFunc = async function () {
            await Swal.fire(
                "Success",
                "Membership plan changed successfully.",
                "success"
            );
            refetch();
            setTimeout(() => {
                refetchReceipts({
                    id: params.id,
                    first: ROWS_PER_PAGE,
                    offset: 0,
                });
            }, 2000);
            await refetchMembershipDetail()
        };
        const errorFunc = async (
            message: string = "Change membership plan failed"
        ) => {
            await Swal.fire("Error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
            // window.location.reload();
        };
        try {
            const { data } = await changeUserSubscription({
                variables: {
                    id: params.id,
                    planId,
                },
            });
            if (
                data &&
                data.changeUserSubscriptionPlan &&
                (data as any).changeUserSubscriptionPlan.error
            ) {
                errorFunc(
                    "Can't charge your card. We will open a new tab automatically to retry payment for membership. Please reload page after payment successful."
                );
                setState(
                    Object.assign(state, {
                        change_plan_invoice_url: (data as any)
                            .changeUserSubscriptionPlan.error.invoice
                            .hosted_invoice_url,
                        processing_change_plan: false,
                    })
                );
                setTimeout(() => {
                    window.open(
                        (data as any)?.changeUserSubscriptionPlan?.error.invoice
                            .hosted_invoice_url
                    );
                }, 3000);
            } else {
                successFunc();
            }
        } catch (err) {
            errorFunc();
        } finally {
            setState({
                ...state,
                processing_change_plan: false,
            });
        }
    };

    const submitEnrollLifetimeWarrantyPlan = async (planId: number) => {
        setState(
            Object.assign(state, {
                processing_change_plan: true,
            })
        );
        setModalState({ ...initModalState, openChange: false });
        Swal.showLoading();
        const successFunc = async function () {
            await Swal.fire(
                "Success",
                "Membership enrolled successfully",
                "success"
            );
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        const errorFunc = async (
            message: string = "Membership enroll failed"
        ) => {
            await Swal.fire("Error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        try {
            const { data } = await changeUserSubscription({
                variables: {
                    id: params.id,
                    planId,
                },
            });
            if (
                data &&
                data.changeUserSubscriptionPlan &&
                (data as any).changeUserSubscriptionPlan.error
            ) {
                errorFunc(
                    "Can't charge your card. We will open a new tab automatically to retry payment for membership. Please reload page after payment successful."
                );
                setState(
                    Object.assign(state, {
                        change_plan_invoice_url: (data as any)
                            .changeUserSubscriptionPlan.error.invoice
                            .hosted_invoice_url,
                        processing_change_plan: false,
                    })
                );
                setTimeout(() => {
                    window.open(
                        (data as any)?.changeUserSubscriptionPlan?.error.invoice
                            .hosted_invoice_url
                    );
                }, 3000);
            } else {
                successFunc();
            }
        } catch (err) {
            errorFunc();
        } finally {
            setState({
                ...state,
                processing_change_plan: false,
            });
        }
    };

    const submitAcceptCancelOfferSubscription = async () => {
        // setModalState({ ...initModalState, openCancelOffer: false });
        setModalState({ ...initModalState, openCancelOfferSuccess: false });

        Swal.showLoading();
        const successFunc = async function () {
            Swal.close();
            setModalState({ ...initModalState, openCancelOfferSuccess: true });
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        const errorFunc = async (message: string = "Claim offer failed") => {
            await Swal.fire("Claim offer error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        try {
            // reason: pause reason
            await claimCancelOffer({
                variables: {
                    id: params.id,
                },
            });
            refetchCheckCancelOfferData();

            successFunc();
        } catch (err) {
            errorFunc(err.message.replace("GraphQL error: ", ""));
        }
    };

    const submitResumeSubscription = async () => {
        setModalState({ ...initModalState, openPause: false });
        Swal.showLoading();
        const successFunc = async function () {
            await Swal.fire(
                "Success",
                "Membership resumed successfully.",
                "success"
            );
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        const errorFunc = async (
            message: string = "Resume membership failed"
        ) => {
            const isPaymentMethodInvalid = message === "Payment method is invalid"
            if(isPaymentMethodInvalid) {
                await Swal.fire("Error", "Please check your payment method", "error");
                history.push(`/payment_method`);
                return;
            }
            await Swal.fire("Error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        try {
            // reason: pause reason
            await resumePaymentSubscription({
                variables: {
                    id: params.id,
                },
            });
            successFunc();
        } catch (err) {
            console.log("error", err)
            // errorFunc();
            errorFunc(err.message.replace("GraphQL error: ", ""));

        }
    };

    const isMonthlyMembership = useMemo(
        () =>
            get(data, "avironSubscription.plan.interval") ===
            MEMBERSHIP_INTERVAL.MONTHLY,
        [data]
    );
    const isAnnualMembership = useMemo(
        () =>
            get(data, "avironSubscription.plan.interval") ===
            MEMBERSHIP_INTERVAL.YEARLY,
        [data]
    );

    const isDuringFreeOffer: boolean = useMemo(() => {
        const offerUntil = get(data, "avironSubscription.remark.offer_until");
        if (!offerUntil) return false;

        const offerUntilNumber = Number(offerUntil);
        if (isNaN(offerUntilNumber)) return false;

        return moment().isBefore(moment.unix(offerUntilNumber));
    }, [data]);

    const isCanChange = () => {
        const isGoModel = get(data, "avironSubscription.plan")?.appIds.includes(CONSTANTS.APP.AVIRON_GO);
        const isAnnual = get(data, "avironSubscription.plan.interval") === MEMBERSHIP_INTERVAL.YEARLY;
        const isCommercial = get(data, "avironSubscription.plan.customerType") === "commercial";
        const isNewMbsPackage2025 = get(data, "avironSubscription.plan.createdAt") && moment(get(data, "avironSubscription.plan.createdAt")).format("YYYY") === MEMBERSHIP_CREATED_AT_2025;
        const isInactiveStatus = get(data, "avironSubscription.state") === "inactive"
        const isActiveStatus = get(data, "avironSubscription.state") === "active"
        if (
            (isInactiveStatus &&
                !!get(data, "avironSubscription.machineId")) || (isGoModel && isAnnual && !isNewMbsPackage2025) || (isNewMbsPackage2025 && isGoModel && isAnnual && isActiveStatus)
        ) {
            return false;
        }
        if (isCommercial) {
            return false
        }
        if(data?.avironSubscription?.remark?.reactiveJulyOffer && isDuringFreeOffer) {
            return false;
        }
        if (isFreeMembership && ["inactive"].includes(
            get(data, "avironSubscription.state")
        )) {
            return false;
        }
        if (get(data, "avironSubscription.remark.reactive") && isDuringFreeOffer && get(data, "avironSubscription.remark.isAnnual") !== "true") {
            return false;
        }
        if (isCancelOffer) {
            return false;
        }
        return (
            ["active", "inactive"].includes(
                get(data, "avironSubscription.state")
            ) &&
            get(data, "avironSubscription.plan.type") === "stripe" &&
            get(data, "avironSubscription.plan.isRecurring") &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithFinance &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithWarrantyAndFinance &&
            isOwnerMembership
        );
    };
    const isCanRetryCharge = () => {
        return (
            membershipData?.status === MEMBERSHIP_STATUS.pastDue
            && isOwnerMembership
        );
    };
    const isCanPause = () => {
        if (isFreeMembership || isCancelOffer) return false;

        if (get(data, "avironSubscription.remark.reactive") && isDuringFreeOffer) {
            return false;
        }

        return (
            ["active"].includes(get(data, "avironSubscription.state")) &&
            get(data, "avironSubscription.plan.type") === "stripe" &&
            get(data, "avironSubscription.plan.isRecurring") &&
            !get(data, "avironSubscription.isPauseCollection") &&
            get(data, "avironSubscription.plan.interval") !== "yearly" &&
            get(data, "avironSubscription.plan.customerType") === "personal" &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithFinance &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithWarrantyAndFinance &&
            isOwnerMembership
        );
    };
    const isCanResume = () => {
        if (isFreeMembership) return false;

        return (
            ["active", "inactive"].includes(
                get(data, "avironSubscription.state")
            ) &&
            get(data, "avironSubscription.plan.type") === "stripe" &&
            get(data, "avironSubscription.plan.isRecurring") &&
            get(data, "avironSubscription.isPauseCollection") &&
            isOwnerMembership
        );
    };

    const isCanCancel = () => {
        return (
            ["active"].includes(get(data, "avironSubscription.state")) &&
            get(data, "avironSubscription.plan.type") === "stripe" &&
            get(data, "avironSubscription.plan.isRecurring") &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithFinance &&
            get(data, "avironSubscription.plan.productId") !==
            MembershipProductType.membershipWithWarrantyAndFinance &&
            isOwnerMembership
        );
    };

    const isCanEnrollLifetime = () => {
        return false;
    };

    const handleOpenEnrollLifetimeWarranty = () => {
        setModalState({ ...initModalState, openEnrollLifetimeWarranty: true });
        return;
    };

    const handleChooseCancel = () => {
        if (checkCancelOfferData?.checkCancelOfferAvailableSubscription) {
            setModalState({
                ...initModalState,
                openCancelOffer: true,
                cancelData: modalState.cancelData,
            });
        } else {
            handleCancelMembership();
        }
    };

    const handleCancelMembership = async () => {
        const successFunc = async function () {
            const res = await Swal.fire(
                "Success",
                "Membership canceled successfully.",
                "success"
            );
            if (!res.isConfirmed) {
                return;
            }
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        const errorFunc = async (
            message: string = "Cancel membership failed"
        ) => {
            await Swal.fire("Error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
            await refetchMembershipDetail()
        };
        try {
            await cancelUserSubscription({
                variables: {
                    id: params.id,
                    reason: modalState?.cancelData?.reason || "",
                    reasonDetail: modalState?.cancelData?.reasonDetail || "",
                },
            });

            successFunc();
        } catch (err) {
            errorFunc();
        } finally {
            setModalState(initModalState);
        }
    };

    const handleSubmitReactive = async () => {
        resetState();
        Swal.showLoading();
        const successFunc = async function () {
            await Swal.fire(
                "Success",
                "Membership successfully reactivated.",
                "success"
            );
            setIsReCall(true);
            refetch();
            refetchReceipts();
            await refetchMembershipDetail()
        };
        const errorFunc = async () => {
            await Swal.fire(
                "Oops",
                `
                It seem like you’re not eligible for
                this offer.
                `,
                "error"
            );

            refetch();
            refetchReceipts();
            window.location.reload();
        };
        const source = sessionStorage.getItem("reactiveSource") || undefined;
        try {
            await reactiveUserSubscription({
                variables: {
                    id: params.id,
                    isHavePromo: false,
                    source,
                },
            });
            successFunc();
        } catch (err) {
            console.log("err: ", err.message);
            errorFunc();
        } finally {
            setModalState(initModalState);
        }
    };

    const handleSubmitFitplanChooseSubscription = async (planId: number) => {
        Swal.showLoading();
        const successFunc = async function () {
            await Swal.fire(
                "Success",
                "Membership changed successfully.",
                "success"
            );
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
        };
        const errorFunc = async (
            message: string = "Change membership plan failed"
        ) => {
            await Swal.fire("Error", message, "error");
            refetch();
            refetchReceipts({
                id: params.id,
                first: ROWS_PER_PAGE,
                offset: 0,
            });
        };
        try {
            await fitplanChooseSubscription({
                variables: {
                    id: params.id,
                    planId,
                },
            });
            successFunc();
        } catch (err) {
            errorFunc();
        } finally {
            setModalState(initModalState);
        }
    };

    const submitRetryChargeSubscription = async () => {
        setModalState({ ...initModalState, openPause: false });
        Swal.showLoading();
        const successFunc = async function () {
            await Swal.fire("Success", "Retry charge successfully.", "success");
            // refetch();
            // delay(refetchReceipts, 2000);
            window.location.reload();
        };
        const errorFunc = async (message: string = "Retry charge failed") => {
            await Swal.fire("Error", message, "error");
            // refetch();
            window.location.reload();
        };
        try {
            // reason: pause reason
            await retryChargeSubscription({
                variables: {
                    token: data?.avironSubscription?.subscriptionToken as string
                },
            });
            successFunc();
        } catch (err) {
            errorFunc();
        }
    };

    const nextfitplanName = useMemo(() => {
        const nextPlanId = get(data, "avironSubscription.remark.choosed_plan_id");
        if (!nextPlanId) {
            if (data?.avironSubscription?.plan?.productId === MembershipProductType.membershipWithWarrantyAndFinance) {
                return "Annual Family Membership with Warranty";
            }
            return "Annual Family Membership";
        }
        const nextPlan = planData?.plans?.nodes?.find((plan) => plan.id === nextPlanId);
        if (nextPlan) {
            return nextPlan.name;
        }
    }, [data, planData]);


    if (loading || receiptLoading || loadingPlan || loadingPage) {
        return (
            <div style={{ height: '100vh' }}>
                <AvironLoading />
            </div>
        );
    }


    return (
        <div className={style["MembershipDetail"]}>
            <Box
                padding={{
                    xs: "16px 32px",
                    md: 0,
                }}
                className={style["membershipBoxWrapper"]}
            >
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Membership detail | Aviron</title>
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
                <GoBack url={location?.pathname} />
                <Stack direction={{ xs: "column-reverse", md: "column" }}>
                    <Box mt="24px">
                        <Grid container>
                            <Grid item md={3}>
                                <PageTitle>Membership detail</PageTitle>
                            </Grid>
                            <Grid item xs={12} md={9} textAlign="end">
                                <Stack
                                    spacing={2}
                                    direction={{ xs: "column", md: "row" }}
                                    alignItems="end"
                                    justifyContent="flex-end"
                                >
                                    {isCanEnrollLifetime() && (
                                        <div
                                            className="enroll-lifetime-container"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                className="limited-time"
                                                style={{
                                                    position: "absolute",
                                                    zIndex: 1,
                                                    background:
                                                        "var(--Neutral-900, #161616)",
                                                    color: "#fff",
                                                    left: "8px",
                                                    top: "-10px",
                                                    borderRadius: "100px",
                                                    padding: "2px 6px",
                                                    border: "solid 2px",
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                }}
                                            >
                                                <svg
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 12 12"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10ZM6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                                                        fill="white"
                                                    />
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M5.25 3.5C5.25 3.22386 5.47386 3 5.75 3C6.02614 3 6.25 3.22386 6.25 3.5V6.22288L7.591 7.061C7.82517 7.20736 7.89636 7.51583 7.75 7.75C7.60364 7.98417 7.29517 8.05536 7.061 7.909L5.72 7.07087C5.42762 6.88814 5.25 6.56767 5.25 6.22288V3.5Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                                LIMITED TIME
                                            </div>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={
                                                    handleOpenEnrollLifetimeWarranty
                                                }
                                            >
                                                Enroll in Lifetime Warranty
                                            </Button>
                                        </div>
                                    )}
                                    {isFitplan && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setModalState({
                                                    ...initModalState,
                                                    openFitPlanChooseMembership:
                                                        true,
                                                });
                                            }}
                                        >
                                            Change Membership
                                        </Button>
                                    )}
                                    {isCanReactiveWithoutPromo && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setModalState({
                                                    ...initModalState,
                                                    openReactiveWithoutPromo:
                                                        true,
                                                });
                                            }}
                                        >
                                            Reactivate
                                        </Button>
                                    )}
                                    {isCanChange() && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                // setModalState({
                                                //     ...initModalState,
                                                //     openChange: true,
                                                // });
                                                history.push(`/membership/${params.id}/upgrade`);
                                            }}
                                        >
                                            CHANGE MEMBERSHIP
                                        </Button>
                                    )}
                                    {isCanRetryCharge() && (
                                        // {true && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setModalState({
                                                    ...initModalState,
                                                    openRetryCharge: true,
                                                });
                                            }}
                                        >
                                            RETRY CHARGE
                                        </Button>
                                    )}
                                    {/* {isCanPause() && isOwnerMembership && (
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                setModalState({
                                                    ...initModalState,
                                                    openPause: true,
                                                });
                                            }}
                                        >
                                            PAUSE MEMBERSHIP
                                        </Button>
                                    )} */}
                                    {isCanResume() && (
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                setModalState({
                                                    ...initModalState,
                                                    openResume: true,
                                                });
                                            }}
                                        >
                                            RESUME MEMBERSHIP
                                        </Button>
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                    <Paper
                        sx={{
                            padding: "32px 38px",
                            margin: "24px 0",
                            position: "relative",
                        }}
                        className={style["memberPaper"]}
                    >
                        <Grid
                            container
                            display="flex"
                            justifyContent="space-between"
                            spacing={2}
                            direction={{
                                xs: "column",
                                sm: "column",
                                md: "row",
                            }}
                        >
                            <Grid item xs={8} sm={12} md={7}>
                                <Typography
                                    variant="h3"
                                    mb="32px"
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontWeight: 400,
                                    }}
                                >
                                    {membershipData.planName}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} sm={12} md={5}>
                                {isOwnerMembership && (
                                    // (isAvironBikeApp ||
                                    //     isAvironRowerApkApp) &&
                                    <div className={style["membershipLink"]}>
                                        <>
                                            {!membershipData?.appIds?.includes(
                                                CONSTANTS.APP.AVIRON_GO
                                            ) &&
                                                !membershipData?.appIds?.includes(
                                                    CONSTANTS.APP.BIKE_GO
                                                ) && (
                                                    <MemberLink
                                                        link={`${CONSTANTS.NAVIGATION_URL.MEMBERSHIP_MACHINE_MANAGE}`.replace(
                                                            ":id",
                                                            params.id
                                                        )}
                                                        text={
                                                            `Products` +
                                                            (membershipData
                                                                ?.constrainTypes
                                                                ?.max_machine
                                                                ? ` ${membershipData?.totalMachines}/${membershipData?.constrainTypes?.max_machine}`
                                                                : "")
                                                        }
                                                    />
                                                )}
                                        </>
                                        <>
                                            {(membershipData?.appIds?.includes(
                                                CONSTANTS.APP.AVIRON_GO
                                            ) ||
                                                membershipData?.appIds?.includes(
                                                    CONSTANTS.APP.BIKE_GO
                                                )) &&
                                                membershipData?.type ===
                                                "warranty" ? (
                                                <></>
                                            ) : (
                                                <MemberLink
                                                    link={`${CONSTANTS.NAVIGATION_URL.MEMBERSHIP_INVITE_LIST}`.replace(
                                                        ":id",
                                                        params.id
                                                    )}
                                                    text={
                                                        `Member List` +
                                                        (membershipData
                                                            ?.constrainTypes
                                                            ?.max_user_family
                                                            ? ` ${membershipData?.totalMembers}/${membershipData?.constrainTypes?.max_user_family}`
                                                            : "")
                                                    }
                                                />
                                            )}
                                        </>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                        {((isFitplan && windowSize.width < 768)) && <Grid
                            container
                            display="flex"
                            justifyContent="space-between"
                            spacing={2}
                            direction={{
                                xs: "column",
                                sm: "column",
                                md: "row",
                            }}
                            paddingBottom={{ xs: "32px" }}
                        >
                            <Grid item xs={12} sm={12} md={12}>
                                <Typography variant="body1" fontWeight={500}>
                                    Your membership will be changed to {nextfitplanName} on{" "}
                                    {moment(get(data, "avironSubscription.startDay")).add(12, 'month').format("MM/DD/YYYY")}
                                </Typography>
                            </Grid>
                        </Grid>}
                        <Grid
                            container
                            display="flex"
                            justifyContent="space-between"
                            spacing={2}
                            direction={{
                                xs: "column",
                                sm: "column",
                                md: "row",
                            }}
                            paddingBottom={{ xs: "32px" }}
                        >
                            <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Membership Key
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        textDecoration: "none !important",
                                        color: "inherit",
                                    }}
                                >
                                    {getAvironKey(membershipData.orgKey)}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Owner Email
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        textDecoration: "none !important",
                                        color: "inherit",
                                    }}
                                >
                                    {get(membershipData, "owner.email")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Status
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        getStatus(
                                            String(membershipData.status),
                                            membershipData?.isPauseCollection
                                        )?.name
                                    }
                                </Typography>
                                {get(data, "avironSubscription.resumeAt") &&
                                    data?.avironSubscription
                                        ?.isPauseCollection &&
                                    data?.avironSubscription.state !==
                                    "ended" && (
                                        <Typography variant="body1">
                                            Until{" "}
                                            {moment(
                                                get(
                                                    data,
                                                    "avironSubscription.resumeAt"
                                                )
                                            ).format("MM/DD/YYYY")}
                                        </Typography>
                                    )}
                            </Grid>
                            <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Start
                                </Typography>
                                <Typography variant="body1">
                                    {get(membershipData, "startAt")
                                        ? moment
                                            .unix(
                                                get(membershipData, "startAt")
                                            )
                                            .format("MM/DD/YYYY")
                                        : "---"}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Machine ID
                                </Typography>
                                <Typography variant="body1">
                                    {get(
                                        data,
                                        "avironSubscription.machineId"
                                    ) || "---"}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} sm={4} md={2}>
                                <Typography variant="subtitle2">
                                    Model
                                </Typography>
                                <Typography variant="body1">
                                    {ModelCell}
                                </Typography>
                            </Grid>
                        </Grid>
                        {((isFitplan && windowSize.width >= 768)) && <Grid
                            container
                            display="flex"
                            justifyContent="space-between"
                            spacing={2}
                            direction={{
                                xs: "column",
                                sm: "column",
                                md: "row",
                            }}
                            paddingBottom={{ xs: "32px" }}
                        >
                            <Grid item xs={12} sm={12} md={12}>
                                <Typography variant="body1" fontWeight={600}>
                                    Your membership will be changed to {nextfitplanName} on{" "}
                                    {moment(get(data, "avironSubscription.startDay")).add(12, 'month').format("MM/DD/YYYY")}
                                </Typography>
                            </Grid>
                        </Grid>}
                        {get(data, "avironSubscription.plan.type") ===
                            "stripe" &&
                            isOwnerMembership && (
                                <>
                                    <Divider
                                        sx={{
                                            position: "absolute",
                                            left: 0,
                                            width: "100%",
                                        }}
                                        className={style["divider"]}
                                    />
                                    <Box
                                        mt="16px"
                                        className={style["ReceiptsWrapper"]}
                                    >
                                        <Typography
                                            variant="h4"
                                            color="#808080"
                                        >
                                            Receipts
                                        </Typography>
                                        <Receipts
                                            receipts={receipts}
                                            totalCount={totalCount}
                                            onPageChange={handleChangePage}
                                            pageSize={ROWS_PER_PAGE}
                                            currentPage={pagination.currentPage}
                                        />
                                    </Box>
                                </>
                            )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: windowSize.width < 768 ? "column" : "row",
                            }}
                        >
                            <div>
                                {isCancelOffer ? (
                                    <p
                                        style={{
                                            textAlign:
                                                windowSize.width < 768
                                                    ? "left"
                                                    : "right",
                                            fontSize: 12,
                                            marginBottom: 0,
                                            borderRadius: "4px",
                                            border: "1px solid var(--neutral-300, #C3C3C3)",
                                            background:
                                                "var(--neutral-100, #E6E6E6)",
                                            padding: "8px",
                                        }}
                                    >
                                        {isDuringCancelOffer ? (
                                            <i>
                                                *This is a discounted rate
                                                applicable to the specific time
                                                period
                                            </i>
                                        ) : (
                                            <i>
                                                *You have activated a special
                                                promotional offer and your
                                                membership rate will be discounted
                                                at your next billing cycle
                                            </i>
                                        )}
                                    </p>
                                ) : (
                                    <p></p>
                                )}
                                {isSubscriptionDiscount ? (
                                    <>
                                        <p
                                            style={{
                                                textAlign:
                                                    windowSize.width < 768
                                                        ? "left"
                                                        : "right",
                                                fontSize: 12,
                                                marginBottom: 0,
                                                borderRadius: "4px",
                                                border: "1px solid var(--neutral-300, #C3C3C3)",
                                                background:
                                                    "var(--neutral-100, #E6E6E6)",
                                                padding: "8px",
                                                display: "inline-block"
                                            }}
                                        >
                                            <i>
                                                *This is a discounted rate applicable to the specific time period
                                            </i>
                                        </p>
                                    </>
                                ) : (
                                    <>
                                    </>
                                )}
                            </div>
                            <div>
                                <Grid container gap={"16px"}>
                                    {/* {isCanEnrollLifetime() && <UnderlineButton onClick={handleOpenEnrollLifetimeWarranty} title="Enroll in Lifetime Membership" />} */}

                                    {isCanCancel() && (isAnnualMembership || isFreeMembership || (get(data, "avironSubscription.remark.reactive") && isDuringFreeOffer)) && (
                                        <UnderlineButton
                                            title="CANCEL MEMBERSHIP"
                                            onClick={() => {
                                                handleTrackingCancellationInitiated();
                                                trackingCancelMembershipClick(
                                                    data as GetAvironSubscriptionQuery
                                                );
                                                history.push(
                                                    `${CONSTANTS.NAVIGATION_URL.MEMBERSHIP_CANCEL_REASONS}?id=${params.id}`
                                                );
                                            }}
                                        />
                                    )}
                                    {isCanPause() && isMonthlyMembership && (
                                        <UnderlineButton
                                            title="PAUSE OR CANCEL MEMBERSHIP"
                                            onClick={() => {
                                                handleTrackingCancellationInitiated();
                                                trackingPauseOrCancelMembershipClick(
                                                    data as GetAvironSubscriptionQuery
                                                );
                                                history.push(
                                                    `${CONSTANTS.NAVIGATION_URL.MEMBERSHIP_PAUSE_OR_CANCEL}?id=${params.id}`
                                                );
                                            }}
                                        />
                                    )}
                                </Grid>
                            </div>
                        </div>

                        <RetryChargeMembershipModal
                            open={modalState.openRetryCharge}
                            onClose={resetState}
                            onSubmit={submitRetryChargeSubscription}
                        />
                        <ChangeMembershipModal
                            open={modalState.openChange}
                            onClose={resetState}
                            state={state}
                            onSubmit={submitChangeSubscriptionPlan}
                            plans={planData?.plans?.nodes || []}
                            membership={data?.avironSubscription}
                        />
                        <KlaviyoUpgradeMembershipModal
                            open={modalState.openUpgradePlan}
                            onClose={resetState}
                            state={state}
                            onSubmit={submitKlaviyoUpgradeSubscriptionPlan}
                            plans={planData?.plans?.nodes || []}
                            membership={data?.avironSubscription}
                        />
                        <KlaviyoUpgradeMembershipSuccessModal
                            open={modalState.openUpgradePlanSuccess}
                            onClose={handleCloseKlaviyoUpgradeSuccessModal}
                        />

                        <ResumeMembershipModal
                            open={modalState.openResume}
                            onClose={resetState}
                            onSubmit={submitResumeSubscription}
                        />
                        <CancelOfferMembershipModal
                            open={modalState.openCancelOffer}
                            onClose={resetState}
                            onSubmit={submitAcceptCancelOfferSubscription}
                            planId={data?.avironSubscription?.planId}
                            onCancel={handleCancelMembership}
                        />
                        <EnrollLifetimeWarrantyModal
                            open={modalState.openEnrollLifetimeWarranty}
                            onClose={resetState}
                            state={state}
                            onSubmit={submitEnrollLifetimeWarrantyPlan}
                            plans={planData?.plans?.nodes || []}
                            membership={data?.avironSubscription}
                        />
                        <ReactiveMembershipModal
                            open={modalState.openReactive}
                            onClose={handleCloseNoticeReactiveModal}
                            onSubmit={handleSubmitReactive}
                        />
                        <ReactiveMembershipWithoutPromoModal
                            open={modalState.openReactiveWithoutPromo}
                            onClose={handleCloseNoticeReactiveWithoutPromoModal}
                            onSubmit={handleSubmitReactive}
                        />
                        <FitPlanChooseMembershipModal
                            open={modalState.openFitPlanChooseMembership}
                            // open={isFitplan}
                            onClose={resetState}
                            state={state}
                            onSubmit={handleSubmitFitplanChooseSubscription}
                            plans={planData?.plans?.nodes || []}
                            membership={data?.avironSubscription}
                        />
                    </Paper>
                </Stack>
            </Box>
            {/* {(loading || receiptLoading) && <AvironLoading />} */}
        </div>
    );
}
